module.exports = __webpack_public_path__ + "img/1,w_600.d5602973.jpg";